<template>
  <div>
    <maritimeService
      :name="heading"
      subProps="Marine industry software designed to streamline operations and improve efficiency"
    />
    <v-container>
      <v-row>
        <v-col sm="12" md="7" lg="7" class="mt-sm-20">
          <v-img :src="require('@/assets/tick.jpg')" class="white--text img" />

          <div class="pt-2 divpara">
            Introducing the most advanced Ticket Management System for vessel
            owners - now you can easily track and manage all of your vessel
            tickets in one place.
            <br /><br />

            Our Ticket Management System offers a range of features to help you
            streamline your ticket management process, including:

            <br /><br />
          </div>

          <div class="texv">
            <v-icon color="indigo darken-4" x-large>
              mdi mdi-ticket-outline </v-icon
            >&nbsp;
            <span class="sicon"><b>Customizable ticket types:</b></span>
            <br />
            <p class="texv">
              Create and customize ticket types to match your specific needs,
              such as maintenance tickets, safety tickets, and more.
            </p>

            <br />

            <v-icon color="indigo darken-4" x-large>
              mdi mdi-bell-outline</v-icon
            >&nbsp;
            <span class="sicon"><b>Automatic notifications:</b></span>
            <br />
            <p class="texv">
              Set up automatic notifications for when tickets are due, so you
              can stay on top of deadlines and avoid any delays.
            </p>

            <br />

            <v-icon color="indigo darken-4" x-large>
              mdi mdi-file-chart-outline</v-icon
            >&nbsp;
            <span class="sicon"><b>Detailed reporting:</b></span>
            <br />
            <p class="texv">
              Generate detailed reports on ticket status, types, and more, to
              get a clear overview of your ticket management process.
            </p>

            <br />
            <v-icon color="indigo darken-4" x-large
              >mdi mdi-cellphone-check</v-icon
            >&nbsp; <span class="sicon"><b>Mobile compatibility:</b></span>
            <br />
            <p class="texv">
              software is fully compatible with both iOS and Android devices, so
              you can access your tickets from anywhere.
            </p>
          </div>

          <br />
          <h2>FEATURES</h2>

          <v-row class="pt-3">
            <v-col v-for="(feature, i) in features" :key="i" cols="12" md="12">
              <base-avatar-card v-bind="feature" align="left" horizontal />
            </v-col>
          </v-row>

          <div>
            With our Ticket Management System, you can improve efficiency,
            reduce the risk of errors, and ensure that all of your vessel
            tickets are tracked and managed effectively. Try it out today and
            see the difference it can make for your business.
          </div>
        </v-col>
        <v-col sm="12" md="5" lg="5"> <base-request /> </v-col>
      </v-row>
    </v-container>

    <p class="text-center pt-5">
      "A one-size-fits-all approach is not effective for either shoes or
      software. Both need to be tailored to the individual user or business to
      be truly effective."
    </p>
  </div>
</template>

<script>
import maritimeService from "../../components/maritime-service.vue";
export default {
  components: {
    maritimeService
  },

  data: () => ({ heading: "" }),
  mounted() {
    this.heading = "Ticket Management System for Vessel Owners";
  },

  data: () => ({
    features: [
      {
        color: "blue darken-2",
        dark: true,
        title: "Unified Ticketing Platform",
        icon: "mdi-ticket-outline",
        text:
          "Seamlessly integrates office IT and vessel IT ticketing systems into one centralized platform for streamlined management."
      },
      {
        color: "blue darken-2",
        dark: true,
        title: "Cross-Platform Accessibility",
        icon: "mdi-lan-check",
        text:
          "Accessible from both onshore offices and vessels, ensuring continuity in issue reporting and resolution regardless of location."
      },
      {
        color: "blue darken-2",
        dark: true,
        title: "AI-Powered Knowledge Base",
        icon: "mdi-robot",
        text:
          "Utilizes AI to build and maintain a comprehensive knowledge base, offering instant access to solutions, troubleshooting guides, and best practices."
      },
      {
        color: "blue darken-2",
        dark: true,
        title: "Smart Ticket Routing",
        icon: "mdi-ticket",
        text:
          "AI-driven ticket routing assigns tickets to the most appropriate support team or personnel, optimizing efficiency in issue resolution."
      },
      {
        color: "blue darken-2",
        dark: true,
        title: "Customizable Ticketing Workflows",
        icon: "mdi-tune",
        text:
          "Adaptable ticketing workflows tailored to the specific needs of the maritime industry, accommodating diverse issue types and escalation protocols."
      },
      {
        color: "blue darken-2",
        dark: true,
        title: "Comprehensive Analytics and Reporting",
        icon: "mdi-google-analytics",
        text:
          "Generates insightful reports and analytics on issue trends, resolution times, and performance metrics for continuous improvement."
      },
      {
        color: "blue darken-2",
        dark: true,
        title: "Compliance and Security",
        icon: "mdi-security",
        text:
          "Ensures adherence to industry regulations and security standards, safeguarding sensitive information within the ticketing system."
      },
      {
        color: "blue darken-2",
        dark: true,
        title: "Real-time Communication",
        icon: "mdi-clock-time-ten-outline",
        text:
          "Facilitates real-time communication between onshore support teams and vessel personnel, enabling swift collaboration and problem-solving."
      },
      {
        color: "blue darken-2",
        dark: true,
        title: "Remote Diagnostics and Support",
        icon: "mdi-remote-desktop",
        text:
          "Enables remote diagnostics and troubleshooting capabilities, minimizing downtime and maximizing operational efficiency."
      },
      {
        color: "blue darken-2",
        dark: true,
        title: "Documentation and Compliance Tracking",
        icon: "mdi-file-document",
        text:
          "Maintains detailed documentation of issue resolutions and compliance-related actions for audit trails and regulatory purpos."
      },
      {
        color: "blue darken-2",
        dark: true,
        title: "Private Cloud Deployment",
        icon: "mdi-cloud",
        text:
          "Ensures data security and accessibility through a dedicated, private cloud environment, offering enhanced control and compliance with industry-specific regulations."
      },
      {
        color: "blue darken-2",
        dark: true,
        title: "Seamless PowerBI Integration",
        icon: "mdi-chart-areaspline",
        text:
          "Integrates seamlessly with PowerBI, enabling comprehensive data visualization, analytics, and reporting for informed decision-making and performance tracking."
      },
      {
        color: "blue darken-2",
        dark: true,
        title: "Unified Vessel IT Support",
        icon: "mdi-ship-wheel",
        text:
          "Provides holistic IT support for vessels, combining hardware and software assistance, network troubleshooting, and maintenance, ensuring uninterrupted operations at sea."
      }
    ]
  })
};
</script>

<style scoped>
.img {
  min-height: 200px;
}
.divpara {
  text-align: justify;
}
h1 {
  font-size: 30px;
}

@media (max-width: 960px) {
  .mt-sm-20 {
    margin-top: 150px;
    padding: 25px;
  }
}

@media (max-width: 800px) {
  .mt-sm-20 {
    margin-top: 140px;
    padding: 25px;
  }
}

@media (max-width: 600px) {
  .mt-sm-20 {
    margin-top: 155px;
    padding: 25px;
  }
}

@media (max-width: 500px) {
  .mt-sm-20 {
    margin-top: 200px;
    padding: 25px;
  }
}

@media (max-width: 400px) {
  .mt-sm-20 {
    margin-top: 220px;
    padding: 25px;
  }
}
</style>
